import Select from 'react-select';
import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import { customStyles } from '../../../../helpers/modal_styles';
import './NameImpuestoEditModal.css'
import { useDispatch } from "react-redux";
import { onEditarNameImpuesto } from '../../../../services/nameimpuestos/nameimpuestoService';
import { updateStateForId } from '../../../../helpers/updateState';


const estado = [
    { value: "0", label: "Desactivado" },
    { value: "1", label: "Activado" },
];



export const NameImpuestoEditModal = ({ setmodalEditar, modalEditar, editar, state, setState }) => {
    const dispatch = useDispatch();
    Modal.setAppElement('#root');

console.log(editar);

    const [formValues, setFormValues] = useState({});

    useEffect(() => {
        const initialState = {
            id: editar.id,
            impuesto: editar.impuesto,
            estado: editar.estado,
        }
        ;
        setFormValues(initialState);
        ;
    }, [editar])





    //FUNCTION========================
    const closeModal = () => {
        setmodalEditar(false);
    }

    const editarModel = async(e) => {
        e.preventDefault();
;
        const resp = await dispatch(onEditarNameImpuesto(
            formValues.id, 
            formValues.impuesto,
            formValues.estado,
            ));

            const newArray = updateStateForId(state, resp);
            setState([...newArray]);
            closeModal();

    }

    //FIN FUNCTION========================


    return (
        <Modal
            isOpen={modalEditar}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
        >
            <div className='popup'>
                

           <center><h3>Editar Impuesto</h3></center>
            <br />
            <form onSubmit={editarModel}>

                <div className="form-row">
                    <div className="form-grupin col-md-12">
                        <input
                            placeholder="Ciudad"
                            type="text"
                            name="impuesto"
                            className="form-control"
                            value={formValues.impuesto}
                            onChange={(e) =>
                                setFormValues({ ...formValues, impuesto: e.target.value })
                            }
                        />
                    </div>
                </div>
                <div className="form-row">
                <div className=" form-grupin col-md-12">
                        <Select
                        options={estado}
                        value={{
                            value: formValues.estado,
                            label: formValues.estado===1?"Activo":"Desactivado"
                          }}
                        placeholder="Estado"  
                        onChange={(e) => setFormValues({ ...formValues, estado: e.value })} 
                        />
                    </div>
                </div>

                <button className="btn btncrear">Editar</button>
            </form>
            </div>

        </Modal>
    )
}
